import { Injectable } from '@angular/core';
import { StorageBaseService } from '@core/storage/storage-base.service';

/**
 * @class SessionStorageService
 * @classdesc Middleware service to access and read/write on SessionStorage's native APIs
 */
@Injectable({
    providedIn: 'root',
})
export class SessionStorageService extends StorageBaseService {
    protected storage: Storage = sessionStorage;
}
